<script type="text/javascript">
  export default {
  };
</script>

<template>
  <div class="market-shares-item-loader">
    <div class="market-shares-item-loader__image">

    </div>
    <div class="market-shares-item-loader__content">
      <div class="market-shares-item-loader__text-1"></div>
      <div class="market-shares-item-loader__text-2"></div>
    </div>
  </div>
</template>

<style lang="scss">
  @import '~styles/settings';

  .market-shares-item-loader {
    display: flex;
    height: 81px;
    background: $white;
    margin-bottom: 10px;
    align-items: center;
    padding: 0 20px;

    &__image {
      width: 40px;
      height: 40px;
      background: linear-gradient(307deg, #07414b, #083037);
      opacity: 0.4;
      border-radius: 4px;
      flex-shrink: 0;
    }

    &__content {
      padding: 20px;
      flex-grow: 1;
    }

    &__text-1 {
      height: 15px;
      background-color: rgba(103, 153, 159, 0.4);
      border-radius: 4px;
      max-width: 150px;

      @include breakpoint($layout-breakpoint) {
        max-width: 217px;
      }
    }

    &__text-2 {
      margin-top: 10px;
      height: 15px;
      background-color: rgba(103, 153, 159, 0.4);
      border-radius: 4px;
      max-width: 150px;

      @include breakpoint($layout-breakpoint) {
        max-width: 217px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketSharesItemLoader.vue